import {determineLocation} from './determineLocation';

const PAGES: Record<string, string> = {'/renew': 'renew', '/reinstate': 'reinstate', '/dissolve': 'dissolve'};
const recorded = new Set<string>();

/** Steps on a public filing page, recorded to see where visitors stop (see PageVisitController::EVENTS). */
export type PageEvent = 'proceed' | 'payment_shown' | 'breakdown' | 'back' | 'charge_accepted' | 'submit' | 'payment_error';

/**
 * Tells the API that a public filing page was opened, with its d= token and src= tag, so email click-throughs can be
 * counted. Fire-and-forget: failures are ignored and never affect the page. Each page and query is recorded once
 * per page load (React strict mode runs effects twice in development).
 */
export function recordPageVisit(pathname: string, search: string): void {
    record(pathname, search, 'visit');
}

/** Records a step on the current filing page (e.g. "view breakdown" opened), once per page load. */
export function recordPageEvent(event: PageEvent): void {
    try {
        record(window.location.pathname, window.location.search, event);
    } catch {
        // Analytics must never break the page.
    }
}

function record(pathname: string, search: string, event: 'visit' | PageEvent): void {
    const page = PAGES[pathname.replace(/\/+$/, '') || '/'];
    const key = `${event} ${pathname}${search}`;
    if (!page || recorded.has(key)) return;
    recorded.add(key);

    const params = new URLSearchParams(search);
    try {
        void fetch(`${determineLocation()}/page-visit`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({page, d: params.get('d'), src: params.get('src'), ...(event === 'visit' ? {} : {event})}),
            keepalive: true,
        }).catch(() => undefined);
    } catch {
        // Analytics must never break the page.
    }
}
